import { useCallback, useMemo } from 'react';

import type { ChipValueType } from '../../../store/slices/chips/types';

export const useSiblingChips = (
  chips: ChipValueType[],
  selectedChip: ChipValueType | null
): (null | ChipValueType)[] => {
  const siblingChip = useCallback((position: -1 | 1, chips: ChipValueType[], selectedChip: ChipValueType | null) => {
    if (!selectedChip) return null;

    const chipIndex = chips.indexOf(selectedChip);

    if (position === -1) {
      // Position Left
      if (chipIndex === 0) return chips[chipIndex + 1];
      if (chipIndex === chips.length - 1) return chips[chips.length - 3];
      return chips[chipIndex - 1];
    } else {
      // Position Right
      if (chipIndex === 0) return chips[chipIndex + 2];
      if (chipIndex === chips.length - 1) return chips[chips.length - 2];
      return chips[chipIndex + 1];
    }
  }, []);

  return useMemo(
    () => [siblingChip(-1, chips, selectedChip), siblingChip(1, chips, selectedChip)],
    [siblingChip, chips, selectedChip]
  );
};
